<template>
  <div>
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <!-- <CCardHeader>Nodes Error Notifications</CCardHeader> -->
        <CCardBody>
          <v-card
            style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
            shaped
          >
            <div class="md-layout">
              <div class="md-layout-item">
                <md-card>
                  <md-card-header  style="  background-color:#31a9e1;">
                    <h4 class="title">Nodes Error Notifications</h4>
                    <p class="category"></p>
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout" v-for="(item, i) in Data" :key="i">
                      <div class="md-layout-item md-medium-size-100">
                        <a>
                          <div class="alert alert-danger" @click="getPath(item.Node)">
                            <button type="button" aria-hidden="true" class="close">×</button>
                            <span>
                              <b>{{item.Node}} {{item.Farmer}}-</b>
                              {{item.msg}}
                            </span>
                            <span>{{item.date}}</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </v-card>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import User from "@/services/Users";
import router from "@/routes";
export default {
  data() {
    return {
      Data: [],
      node: [],
      msg: [],
      date: [],
      type: "danger",
      notifications: {
        topCenter: false
      }
    };
  },
  methods: {
    getPath(id) {
      router.push(`/dashboard?id=${id}`);
    },
    notifyVue() {
      var color = "danger";
      for (let i = 0; i <= this.data.lenght; i++) {
        this.$notify({
          message: this.Data[i].Node + " : " + this.Data[i].msg,
          icon: "add_alert",
          horizontalAlign: "left",
          verticalAlign: "top",
          type: this.type
        });
      }
    }
  },
  created() {
    User.getNotifs()
      .then(r => {
        this.Data = r.data.reverse();
      })
      .catch(er => window.console.log(er));
  }
};
</script>
